<script>
  import { getContext, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
 
  import {SEARCH_EVENTS} from '../../graphql/events';
  
  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';
  import Event from './components/event.html';

  import Plus from '../../components/buttons/plus';
  import Link from '../../utils/link';
  import Search from '../../components/inputs/search';
  import CoordinatorInput from '../../components/inputs/coordinator';
  import TextInput from '../../components/inputs/text';
  import DateInput from '../../components/inputs/date';
  import SwitchInput from '../../components/inputs/switch';
  import Form from '../../components/inputs/form';
  import LoadMore from '../../components/buttons/loadmore';
  import SectionNav from '../../components/navigation/section'

  let search = {};
  let coordinator;
  let query = client.watchQuery({ query: SEARCH_EVENTS, variables: {search} });
  let results = {loading: true};
  let response;

  function filterResults(events) {;
    if(coordinator) {
      events = events.filter(e => e.coordinator && e.coordinator.id === coordinator)
    }
    return events;
  }

  function setResponse({data, loading, error, networkStatus}) {
    response = data && data.events ? filterResults(data.events.docs) : [];
    results = {
      loading,
      page: data && data.events ? data.events.page : 1,
      total: data && data.events ? data.events.total : 0,
      events: data && data.events ? filterResults(data.events.docs) : []
    }
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({error, loading: false});
    }
  });

  function searchEvents() {
    query.refetch({search, page: 1});
  }

  function filterEvents() {
    results = {
      loading: false,
      page: results.page,
      total: filterResults(response).length,
      events: filterResults(response)
    }
  }

  function loadMore() {
    query.fetchMore({
      variables: {
        search,
        page: results.page + 1
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          people: {
            ...fetchMoreResult.events,
            docs: [...prev.events.docs, ...fetchMoreResult.events.docs]
          }
        });
      }
    });
  }
</script>




<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>{results.total || 0} Upcoming Events</h1>
  </div>
  <div class="cell small-12 medium-6 text-right">
    <Link href="/events/new">
      <Plus label="ADD EVENT" />
    </Link>
  </div>
  <div class="cell small-12 medium-9">
    {#if results.loading}
      <Loader></Loader>
    {/if}
    {#if !results.loading}
      <div class="grid-x grid-margin-x small-up-1">
        {#each results.events as event, i (event.id)}
          <div class="cell">
            <Event event={event} />
          </div>
        {/each}
      </div>
    {/if}
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav>
      <Form>
        <div class="grid-x grid-margin-x">
          <div class="cell small-12 medium-12">
            <div class="form-group">
              <TextInput 
                on:input="{searchEvents}" 
                bind:value={search.text} 
                label="Event Name"
                placeholder="Search Events"
              ></TextInput>
            </div>
          </div>
          <div class="cell small-12 medium-12">
            <div class="form-group">
              <CoordinatorInput 
                bind:value={coordinator} 
                on:change="{filterEvents}" 
                label="Coordinator" 
                placeholder="Program Coordinator" 
              ></CoordinatorInput>
            </div>
          </div>
          <div class="cell small-12 medium-12">
            <div class="form-group">
              <DateInput 
                bind:value="{search.startDate}"
                on:change="{searchEvents}" 
                label="Start Date" 
                placeholder="Start Date" 
              ></DateInput>
            </div>
          </div>

          <div class="cell small-12 medium-12">
            <div class="form-group">
              <DateInput 
                bind:value="{search.endDate}"
                on:change="{searchEvents}" 
                label="End Date" 
                placeholder="End Date" 
              ></DateInput>
            </div>
          </div>

          
        </div>
      </Form>
    </SectionNav>
  </div>
</div>
